module.exports = __webpack_public_path__ + "media/images/tokyo_tour_en01-f34f44a394378e6f0cd91efe525fe144.jpg";